import React from 'react'

export default function Input({ inputType, inputId, placeholder, defaultValue, classNames, disabled, required, ...props }) {
    return (
        <input type={inputType} required={required} id={inputId} {...(props)} placeholder={placeholder} disabled={disabled} defaultValue={defaultValue} className={`p-3 placeholder:text-[#D9D9D9] ${disabled ? "text-[#ccc]" : "text-[var(--primary)]"} text-[18px] w-full bg-white border border-[#DEDEDE] rounded-[5px] ${classNames}`} />
    )
}
